import { useSelector } from "react-redux";
import { Navigate, Outlet, useLocation } from "react-router-dom";
export const RequireAuth = () => {
  const { token } = useSelector((state) => state.auth);
  const location = useLocation();
  return token ? (
    <Outlet />
  ) : (
    <Navigate to="/" state={{ from: location }} replace />
  );
};
